/* By Siu */

document.addEventListener('DOMContentLoaded', function() {

    // Add the .sort-custom div
    function moveSortingMenu() {
      var oldFilter = document.querySelector('.collection-toolbar__button-list');
      var oldFilterContainer = document.querySelector('.collection-toolbar');
      if (oldFilter) {        
          var ulElement = document.querySelector('.collection-toolbar');
  
          // Move the .sort-by div inside the .sort-custom div
          var sortByElement = document.querySelector('#gf-controls-container');
          if (sortByElement && ulElement) {
              ulElement.prepend(sortByElement);
              oldFilterContainer.removeChild(oldFilter);
          }
      }
    }
  
    function cancelTimers() {
      clearInterval(timerMoveSortingMenu);
    }

    function fixQuickAddFn() {
      // Select all elements with the class "collection__main product-card form.shopify-product-form"
      const forms = document.querySelectorAll('.collection__main product-card form.shopify-product-form');
      
      // Loop through each form and wrap it with <product-form>
      forms.forEach(function(form) {

        if (form.parentNode.tagName.toLowerCase() !== 'product-form') {
          // Create a new <product-form> element
          const wrapper = document.createElement('product-form');
          
          // Insert the <product-form> wrapper before the form
          form.parentNode.insertBefore(wrapper, form);
          
          // Move the form inside the newly created <product-form>
          wrapper.appendChild(form);
        }
      });
    }
  
    var timerMoveSortingMenu;
    var fixQuickAdd;
  
    timerMoveSortingMenu = setInterval(moveSortingMenu, 100);
    setTimeout(cancelTimers, 10000);
    fixQuickAdd = setInterval(fixQuickAddFn, 300);
});